import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Container, Row, Col } from 'react-bootstrap';
import { getSortedFacilities } from '../../../../src/web/utils/distanceUtils';
import Button from '../../../../modules/react/components/stateless/Button';
import FacilityPicWithAddress from '../../../components/stateless/FacilityPicWithAddress';
import style from './styles.scss';

const propTypes = {
  user: PropTypes.shape({
    latitude: PropTypes.string,
    longitude: PropTypes.string,
  }).isRequired,
  allFacilities: PropTypes.arrayOf({
    address: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    }),
  }),
  isEditable: PropTypes.bool.isRequired,
  allFacilitiesPage: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

const defaultProps = {
  allFacilities: undefined,
  allFacilitiesPage: undefined,
};

const LocationsNearYou = ({
  user,
  allFacilities,
  isEditable,
  allFacilitiesPage,
}) => {
  const [coordinates, setCoordinates] = useState({});

  useEffect(() => {
    window.navigator.geolocation.getCurrentPosition((pos) => {
      setCoordinates(pos.coords);
    });
  }, []);

  const renderViewAllLink = () => {
    const content = (
      <h3 className={`${style.viewAll} color-primary-foreground`}>
        View All
      </h3>
    );

    return allFacilitiesPage && !isEditable
      ? (
        <a href={allFacilitiesPage.path}>
          {content}
        </a>
      )
      : content;
  };

  const renderViewAllButton = () => {
    const content = (
      <Button
        variant="primary"
        className={[
          style.viewAllMobile,
          'color-secondary-background',
          'color-primary-background-hover',
          'button-style-class',
        ].join(' ')}
      >
      View All
      </Button>
    );

    return allFacilitiesPage && !isEditable
      ? (
        <a href={allFacilitiesPage.path}>
          {content}
        </a>
      )
      : content;
  };

  if (!allFacilities) { return null; }

  const sortedFacilities = getSortedFacilities(coordinates, user, allFacilities, 2);

  return (
    <Container>
      <Row>
        <Col md={6} sm={12}>
          <h2 className="color-primary-foreground">
              Locations Near You
          </h2>
        </Col>
        <Col md={6} sm={12}>
          {renderViewAllLink()}
        </Col>
      </Row>
      <Row>
        {sortedFacilities.map(facility => (
          <Col md={6} xs={12} key={facility.id}>
            <FacilityPicWithAddress facility={facility} isEditable={isEditable} />

          </Col>
        ))
          }
      </Row>
      <Row>
        <Col xs={12}>
          {renderViewAllButton()}
        </Col>
      </Row>
    </Container>
  );
};

LocationsNearYou.propTypes = propTypes;
LocationsNearYou.defaultProps = defaultProps;

LocationsNearYou.fragments = {
  facility: gql`
    fragment FacilityLocationsFacility on Facility {
      ...FacilityPicWithAddressFacility
    }

    ${FacilityPicWithAddress.fragments.facility}
  `,
  page: gql`
    fragment FacilityLocationsSite on Page {
      path
    }
  `,
};

export default LocationsNearYou;
